var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-icon-container-wrapper -link"},[_c('div',{staticClass:"icon-container -plus"},[_c('i',{staticClass:"fa fa-plus fa-2x text-white"})]),_c('div',{staticClass:"icon-container -pen"},[_c('i',{staticClass:"fa fa-pen fa-3x text-white"})])])
}]

export { render, staticRenderFns }